import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../ui/button';
import type { ActionButton } from '../../../application/services/notesToHank/NotesToHankTypes';

export interface V2ActionButtonsProps {
  actions: ActionButton[];
  onPress: (actionId: string, label: string, clientCommand?: string) => void;
  pressedIds: Set<string>;
}

export function V2ActionButtons({
  actions,
  onPress,
  pressedIds,
}: V2ActionButtonsProps) {
  if (actions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {actions.map((action) => {
        const isPressed = pressedIds.has(action.id);

        if (isPressed) {
          return (
            <Button
              key={action.id}
              variant="ghost"
              size="sm"
              disabled
              className="opacity-50"
              aria-label={`${action.label} complete`}
            >
              <Check className="size-3.5" />
              {action.label}
            </Button>
          );
        }

        return (
          <Button
            key={action.id}
            variant="outline"
            size="sm"
            onClick={() =>
              onPress(action.id, action.label, action.clientCommand)
            }
          >
            {action.label}
          </Button>
        );
      })}
    </div>
  );
}
